/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const CircleQuestionRegularV6 = (props) => (
  <Icon {...props} name="Circle Question Regular V6">
    <path d="M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8c4.419 0 8-3.581 8-8s-3.581-8-8-8zm0 14.5c-3.584 0-6.5-2.916-6.5-6.5S4.416 1.5 8 1.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-4c-.563 0-1 .437-1 1s.409 1 1 1c.534 0 1-.437 1-1s-.466-1-1-1zM9.034 4H7.437A2.174 2.174 0 0 0 5.25 6.188c0 .406.344.75.75.75s.75-.344.75-.75c0-.375.284-.688.659-.688h1.597c.403 0 .744.313.744.688 0 .25-.125.441-.344.566L7.625 7.845a.77.77 0 0 0-.375.656v.5c0 .406.344.75.75.75s.75-.344.75-.75v-.063l1.409-.875a2.23 2.23 0 0 0 1.062-1.875C11.249 4.969 10.28 4 9.034 4z" />
  </Icon>
);

export default CircleQuestionRegularV6;
